// Handbars helper to shorten returned string
module.exports = function (passedString, startstring, endstring) {
    var theString = passedString.substring(startstring, endstring);
    return theString
};